import { Component, Input } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ModuleType } from '../../enums/allEnums';
import { ComponentImageHistoryComponent } from './component-image-history.component';

@Component({
  selector: 'app-component-image-history-button',
  templateUrl: './component-image-history-button.component.html',
  styleUrls: ['./component-image-history-button.component.scss']
})
export class ComponentImageHistoryButtonComponent {

  @Input() module!: ModuleType;
  @Input() equipmentId!: number;
  @Input() implementId!: number;
  @Input() componentId!: number;
  @Input() obsPointId!: number;
  @Input() code!: string;
  @Input() imageHistoryAvailable: boolean;
  @Input() inspectionId!: number;

  @Input() componentImages: any[] = [];

  //constructor(private dialog: MatDialog) { }
  constructor(private dialog: MatDialog) {
    console.log('ComponentImageHistoryButtonComponent created');
  }

  ngOnInit() {
    console.log('moduleType', this.module);
    console.log('imageHistoryAvailable', this.imageHistoryAvailable);
  }
  openPhoto() {
    this.dialog.open(ComponentImageHistoryComponent, {
      width: '80%',
      height: '95%',
      data: {
        module: this.module,
        equipmentId: this.equipmentId,
        implementId: this.implementId,
        componentId: this.componentId,
        obsPointId: this.obsPointId,
        code: this.code,
        inspectionId: this.inspectionId
      }
    });
  }
}
